import React, { Component } from 'react';
import AvatarImg from '../../../../public/images/nopicture.png';

const ModalRight = props => (
  <div className={props.modalRight ? `container-modal-right` : `container-modal-right hide`}>
    <div className="box-modal">
      <a className="close" onClick={props.handleModalRight}>
        <i className="fas fa-times-circle" />
      </a>
      <div className="container-detail-modal-right">
        <h3>
          {props.language.detail_waiting_times.fufillment.breakUnder} 8
          {props.language.detail_waiting_times.fufillment.time}
        </h3>
        <h4> {props.language.detail_waiting_times.fufillment.homeworkInfo}</h4>

        <div className="box-detail-modal-right--user">
          <div className="box-detail--user--one">
            <h5>{props.language.detail_waiting_times.fufillment.timeOfUnfufillment}: 27/06</h5>
            <h5 className="red">{props.language.detail_waiting_times.fufillment.expired}: 27/06</h5>

            <ul>
              <li>{props.language.detail_waiting_times.fufillment.operation}: Operación 1</li>
              <li>{props.language.detail_waiting_times.fufillment.initBreak}: 27/06 17:00 hrs</li>
              <li>{props.language.detail_waiting_times.fufillment.doneBreak}: 27/06 23:59 hrs</li>
            </ul>

            <span>{props.language.detail_waiting_times.fufillment.unfulfillment}</span>
          </div>
          <div className="box-detail--user--two">
            <img src={AvatarImg} alt="icon" />

            <h5>{props.language.detail_waiting_times.fufillment.driver}:Cristóbal Maturana</h5>
          </div>
        </div>
        <h4>{props.language.detail_waiting_times.fufillment.homeworkManagment}</h4>
        <div className="form-input top">
          <label>{props.language.detail_waiting_times.fufillment.reason}</label>
          <textarea placeholder={props.language.detail_waiting_times.fufillment.placeholderText} />
        </div>
        <div className="form-input top">
          <label>{props.language.detail_waiting_times.fufillment.manage}</label>
          <textarea placeholder={props.language.detail_waiting_times.fufillment.placeholderText} />
        </div>
        <div className="form-input top">
          <label className="fileContainer">
            {props.language.detail_waiting_times.fufillment.uploadFile}{' '}
            <i className="fas fa-paperclip" />
            <input type="file" />
          </label>
        </div>
        <div className="form-input top center">
          <input
            type="button"
            value={props.language.detail_waiting_times.fufillment.closeButton}
            className="green"
          />
          <input
            type="button"
            value={props.language.detail_waiting_times.fufillment.cancelButton}
          />
        </div>
      </div>
    </div>
  </div>
);

export default ModalRight;



// WEBPACK FOOTER //
// ./source/client/components/detail_fulfillment/modalRight.jsx